import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import AddressIcon from '_assets/svgs/address-icon.svg'
import Svg from '_components/svg'
import { makeStyles } from '@material-ui/core/styles'

const FormattedAddress = ({
  address,
  number,
  complement,
  neighborhood,
  city,
  uf,
  googleMapsLink,
}) => {
  // Linha 1: [Endereço], [Número], [Complemento]
  const line1 = `${address || ''}${number ? `, ${number}` : ''}${
    complement ? `, ${complement}` : ''
  }`

  // Linha 2: [Bairro] - [Cidade] - [UF]
  const line2 = `${neighborhood || ''}${city ? ` - ${city}` : ''}${uf ? ` - ${uf}` : ''}`

  const useStyles = makeStyles(() => ({
    addressContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
    },
    addressIcon: {
      width: '24px',
      height: '24px',
    },
  }))

  const styles = useStyles()

  return (
    <div className={styles.addressContainer}>
      <div>
        <Typography style={{ fontSize: '16px' }} variant="body2">
          {line1 || 'Endereço não disponível'}
        </Typography>
        {line2 && (
          <Typography style={{ fontSize: '16px' }} variant="body2">
            {line2}
          </Typography>
        )}
      </div>
      {googleMapsLink && (
        // eslint-disable-next-line jsx-a11y/control-has-associated-label
        <a href={googleMapsLink} target="_blank" rel="noopener noreferrer">
          <Svg icon={AddressIcon} className={styles.addressIcon} />
        </a>
      )}
    </div>
  )
}

FormattedAddress.propTypes = {
  address: PropTypes.string,
  number: PropTypes.string,
  complement: PropTypes.string,
  neighborhood: PropTypes.string,
  city: PropTypes.string,
  uf: PropTypes.string,
  googleMapsLink: PropTypes.string,
}

FormattedAddress.defaultProps = {
  address: '',
  number: '',
  complement: '',
  neighborhood: '',
  city: '',
  uf: '',
  googleMapsLink: '',
}

export default FormattedAddress
